import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DateAdapter, MatPaginator, MatSort, MatTableDataSource, ThemePalette } from '@angular/material';
import { ToastrManager } from 'ng6-toastr-notifications';
import { ColorLineMaster, LineMaster } from '../AllModels';
import { HttpmethodsService } from '../shared/service/httpmethods.service';
import * as moment from 'moment';
import { createColorLineMasterURL, getByAllColorLineMasterURL, getByIdColorLineMasterURL, updateColorLineMasterURL } from '../AllURL';


@Component({
  selector: 'app-colorlinemaster',
  templateUrl: './colorlinemaster.component.html',
  styleUrls: ['./colorlinemaster.component.css']
})
export class ColorlinemasterComponent implements OnInit {

  colorLineMasterForm: FormGroup;
  colorLineMasterModel = new ColorLineMaster();
  isEdit: boolean = true;
  hide = true;
  mobileMsg: string;
  mobFlag: boolean = false;
  textColorMobile: string;

  constructor(private formBuilder: FormBuilder, public toastr: ToastrManager, private httpService: HttpmethodsService, private dateAdapter: DateAdapter<Date>, private datePipe: DatePipe
  ) {
    this.dateAdapter.setLocale('en-GB');
  }

  displayedColumns: string[] = ['Sr.No.', 'Line Name', 'StartTime', 'EndTime', 'Date', 'Status', 'Action'];
  dataSource = new MatTableDataSource<ColorLineMaster>();
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild('epltable', { static: false }) epltable: ElementRef;

  @ViewChild('picker', { static: false }) picker: any;
  @ViewChild('picker1', { static: false }) picker1: any;

  public date: moment.Moment;
  public disabled = false;
  public showSpinners = true;
  public showSeconds = false;
  public touchUi = false;
  public enableMeridian = false;
  public minDate: moment.Moment;
  public maxDate: moment.Moment;
  public stepHour = 1;
  public stepMinute = 1;
  public stepSecond = 1;
  public color: ThemePalette = 'primary';
  public dateControl = new FormControl(new Date());

  public date1: moment.Moment;
  public disabled1 = false;
  public showSpinners1 = true;
  public showSeconds1 = false;
  public touchUi1 = false;
  public enableMeridian1 = false;
  public minDate1: moment.Moment;
  public maxDate1: moment.Moment;
  public stepHour1 = 1;
  public stepMinute1 = 1;
  public stepSecond1 = 1;
  public color1: ThemePalette = 'primary';
  public dateControl1 = new FormControl(new Date());

  ngOnInit() {
    this.colorLineMasterForm = this.formBuilder.group({
      name: new FormControl('', [Validators.required,]),
      date: new FormControl('', [Validators.required]),
      status: new FormControl('', [Validators.required]),
    })
  this.getAllColorLine();
    this.hide = true;
  }
  checkboxChanged(event) {

  }

  SaveColorLine() {
    if (this.isEdit) {
   
      this.httpService.postRequest(createColorLineMasterURL, this.colorLineMasterModel).subscribe((data: any) => {
        if (data) {
          this.isEdit = true;
          this.toastr.successToastr('Save Successfully...!', 'Success!', { timeout: 500 });
          this.getAllColorLine();
          this.colorLineMasterForm.reset();
          this.colorLineMasterModel = new ColorLineMaster();
          this.mobileMsg = " ";

        }
        else {
          this.toastr.errorToastr("Something went Wrong.", "Error");
        }
      })

    }
    else {

      this.httpService.putRequest(updateColorLineMasterURL, this.colorLineMasterModel).subscribe((data: any) => {
        if (data) {
          this.isEdit = true;
          this.toastr.successToastr('Update Successfully...!', 'Success!', { timeout: 500 });
          this.getAllColorLine();
          this.colorLineMasterForm.reset();
          this.colorLineMasterModel = new ColorLineMaster();

        }
        else {
          this.toastr.errorToastr("Something went Wrong.", "Error");
        }
      })
  
    }
  }



  getColorLineMasterById(colorLineId) {
    this.httpService.getRequest(getByIdColorLineMasterURL + "/" + colorLineId).subscribe((data: any) => {
      this.colorLineMasterModel = data;
      this.colorLineMasterModel.startTime = new Date(data.startTime);
      this.colorLineMasterModel.endTime = new Date(data.endTime);
      this.isEdit = false;
      const element = document.querySelector('#scrollId');
      element.scrollIntoView();
    })
  }


  getAllColorLine() {
    this.httpService.getRequest(getByAllColorLineMasterURL).subscribe((data: any) => {
      if (data) {
      
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.paginator = this.paginator;
      }
      else {
        this.toastr.errorToastr("No Records Found.", "Error");
      }
    })
  }
   ///////////////////////For Search ////////////////////
   applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

}
